import { type MylensesPageView } from "@snapchat/blizzard-schema";

export interface PageViewEventData {
    event: MylensesPageView["event_name"];
    path?: string;
    namespace?: string;
}

export const createPageViewEvent = (
    { event, path, namespace }: PageViewEventData,
    sessionId: string,
): MylensesPageView => ({
    event_name: event,
    path,
    namespace,
    mylenses_session_id: sessionId,
});
